import { HeaderScrollView } from "@-/dev.improve.haniverse.components.ui.header-scroll";
import { SkeletonGroup } from "@-/dev.improve.haniverse.components.ui.skeleton";
import { useToolbarGridMetrics } from "@-/dev.improve.haniverse.components.ui.toolbar.button.view";
import type { ReactNode } from "react";

/**
 * The Primitives and Words lists scroll beneath a floating pill toolbar: `headerOverlap` reserves
 * its height (plus the header-scroll gap) and cards sit 4px from the edges and from each other.
 */
export function BrowseFloatingToolbarSkeletonPage({
  accessibilityLabel,
  children,
  testID,
}: {
  accessibilityLabel: string;
  children: ReactNode;
  testID: string;
}) {
  const { height: toolbarHeight } = useToolbarGridMetrics();
  return (
    <HeaderScrollView
      className="flex-1 bg-background"
      contentContainerClassName="px-1 pb-24"
      glassHeaderOverlap={toolbarHeight}
      headerOverlap={toolbarHeight}
      scrollEnabled={false}
    >
      <SkeletonGroup accessibilityLabel={accessibilityLabel} className="gap-1" testID={testID}>
        {children}
      </SkeletonGroup>
    </HeaderScrollView>
  );
}
